exports = module.exports = require("../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".converted-badge[data-v-41d746e0]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:12px;font-weight:700;padding:4px 10px;border-radius:999px;white-space:nowrap;background:#f3f4f6;color:#6b7280;border:1px solid #e5e7eb}.converted-badge.converted[data-v-41d746e0]{background:#eff6ff;color:#1d4ed8;border-color:#bfdbfe}.converted-badge.contact[data-v-41d746e0]{background:#fef3c7;color:#92400e;border-color:#fde68a}", ""]);

// exports
